module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/admin/export-ab9f2e1038319202effdbd4ecdd30ee9.svg&quot;;"